import { render, staticRenderFns } from "./MapMenu.vue?vue&type=template&id=544387c4"
import script from "./MapMenu.vue?vue&type=script&lang=js"
export * from "./MapMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports